import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import CreatePumpDomesticQuotation from "./PumpDomesticQuotation/CreatePumpDomestic";
import CreatePumpInternationalQuotation from "./PumpInternationalQuotation/CreatePumpInternationalQuotation";
import CreateAraiMfgQuotation from "./AraiMfgQuotation/CreateAraiMfgQuotation";
import CreateAraiMfgDomesticQuotation from "./AraiMfgDomesticSQ/CreateAraiMfgDomesticSQ";

const CreateSOQuotation = () => {
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <CreatePumpDomesticQuotation />;
      } else if (productCategory === "International") {
        return <CreatePumpInternationalQuotation />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <CreateAraiMfgDomesticQuotation />;
      } else if (productCategory === "International") {
        return <CreateAraiMfgQuotation />;
      }
    } else {
      return null;
    }
  }

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Add Quotation</h6>
          <Link to="/quotationIndexTable/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Quotation Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                  }}
                  value={productType}
                  disabled={productType ? true : false}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Quotation Category:</Form.Label>
                <Form.Select
                  disabled={!productType ? true : false || productCategory ? true : false}
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
};

export default CreateSOQuotation;
